module.exports = __webpack_public_path__ + "static/the-lifecycle-of-software-objects-9354ec44f20d88577f53bec0533b63ba.jpg";